'use client'

import { Input } from '@shared/components/Search/Search'
import {
  useSearch,
  type ISearchFilters,
} from '@shared/components/Search/SearchProvider'
import { XIcon } from 'lucide-react'
import Button from '@shared/components/Button/Button'
import { button } from '@shared/components/Search/Search.css'
import { useEffect } from 'react'

export function CategorySearch({
  name,
  documentType,
}: {
  name: string
  documentType: ISearchFilters['documentType']
}) {
  const { setQuery, query, pending, setFilter, filter } = useSearch()

  /** Make sure to initially only display the law items, but when searching with a query that we also show clause results */
  useEffect(() => {
    if (!documentType?.includes('law')) return

    if (!query && filter?.documentType?.includes('clause')) {
      setFilter({ ...filter, documentType: ['law'] })
    } else if (query && !filter?.documentType?.includes('clause')) {
      setFilter({ ...filter, documentType: ['law', 'clause'] })
    }
  }, [query, documentType, setFilter, filter?.documentType])

  return (
    <Input
      placeholder={`${name} durchsuchen`}
      onChange={(event) => {
        setQuery(event.currentTarget.value)
      }}
      value={pending?.query ?? query}
      style={{ borderRadius: 14, maxWidth: '26em' }}
      endWidget={<ClearSearchButton />}
    />
  )
}

function ClearSearchButton() {
  const { setQuery, query } = useSearch()
  if (!query) return null

  return (
    <Button
      title='Löschen'
      style={{ marginRight: 9 }}
      square
      circular
      className={button}
      size='tiny'
      onClick={() => {
        setQuery('')
      }}
    >
      <XIcon size={16} style={{ opacity: 0.85 }} />
    </Button>
  )
}
